import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="main-header">
      <nav className="navbar">
        <div className="container header-content">
          <Link to="/" className="nav-logo">
            <h1>Ebamba Travel & Tours</h1>
          </Link>

          <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
            <li><NavLink to="/" end className={({ isActive }) => isActive ? 'active-link' : ''} onClick={toggleMenu}>Home</NavLink></li>
            <li><NavLink to="/tours" className={({ isActive }) => isActive ? 'active-link' : ''} onClick={toggleMenu}>Tours</NavLink></li>
            <li><NavLink to="/about" className={({ isActive }) => isActive ? 'active-link' : ''} onClick={toggleMenu}>About</NavLink></li>
            <li><NavLink to="/contact" className={({ isActive }) => isActive ? 'active-link' : ''} onClick={toggleMenu}>Contact</NavLink></li>
          </ul>

          <div className="menu-toggle" onClick={toggleMenu}>
            <i className={isOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
